import React, { useState } from 'react';
import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { i18n_add_to_calendar } from '@yi/i18n/phrases/i18n_add_to_calendar';

import { IconAddToCalendar } from '~/src/components/icons';
import { useLocale } from '~/src/components/LocaleProvider';
import { useMenu } from '~/src/components/Menu';
import { breakpoints, jwPlayerModalZIndex, leftPanelZIndex, sideNavWidth } from '~/src/styles';

import { LazyAddToCalendar as AddToCalendar } from './LazyAddToCalendar';
import { MenuItemStyles, StyledMenuItem } from '../elements';

const Button = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
  ${MenuItemStyles}
`;

const Modal = styled(Dialog, {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'playerMode',
})<{ playerMode: boolean }>`
  z-index: ${({ playerMode }) => (playerMode ? jwPlayerModalZIndex + 10 : leftPanelZIndex - 50)};
  .MuiDialog-container > .MuiPaper-root {
    padding-top: var(--Header-Height);
    ${breakpoints.minDesktopLg} {
      padding-left: ${sideNavWidth};
    }
    height: 100%;
    width: 100%;
    max-width: unset;
    max-height: unset;
    margin: 0;
    border: 0;
    border-radius: unset;
    overflow: unset;
  }
` as React.FC<DialogProps & { playerMode: boolean }>;

interface Props {
  /**
   * Player modal has very high z-index, so context menu modal should have high z-index as well
   * whereas in normal mode main layout header should be above the context menu modal, hence z-index cannot be very high
   * 'playerMode' enables high z-index mode
   */
  playerMode?: boolean;
}
export const AddToCalendarMenu: React.FC<Props> = ({ playerMode = false }) => {
  const { locale } = useLocale();
  const { onClose } = useMenu();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <StyledMenuItem key="AddToCalendar">
        <Button
          style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          <IconAddToCalendar style={{ width: '20px' }} />
          {i18n_add_to_calendar(locale)}
        </Button>
      </StyledMenuItem>
      <Modal open={isModalOpen} playerMode={playerMode}>
        <AddToCalendar
          onClose={() => {
            setIsModalOpen(false);
            onClose();
          }}
          playerMode
        />
      </Modal>
    </>
  );
};
